import { Check } from "lucide-react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import EmailTemplatePicker from "./EmailTemplatePicker";

export const LANGS = ["en", "it", "de", "fr", "es", "pl"];
export const isFilled = (v) => !!(v?.subject.trim() && v?.body.trim());

const field = "bg-slate-900 border-slate-700 text-slate-100 text-sm";

export default function GroupVersionEditor({ versions, lang, onLang, onChange, t }) {
  const v = versions[lang];
  const set = (key) => (e) => onChange(lang, { [key]: e.target.value });
  return (
    <div className="tech-card p-4 space-y-3" data-testid="group-version-editor">
      <div className="label-tech text-slate-400">{t("groupEmail.versionsTitle")}</div>
      <div className="flex flex-wrap gap-1" role="tablist">
        {LANGS.map((l) => (
          <button key={l} role="tab" aria-selected={lang === l} onClick={() => onLang(l)}
            className={`px-2.5 py-1 text-[11px] rounded border font-mono-data flex items-center gap-1 transition-colors ${
              lang === l ? "border-amber-500 text-amber-300 bg-amber-500/10" : "border-slate-700 text-slate-400 hover:text-slate-200"}`}
            data-testid={`group-lang-${l}`}>
            {l.toUpperCase()}{l === "en" && <span className="text-amber-500">*</span>}
            {isFilled(versions[l]) && <Check size={11} className="text-emerald-400" data-testid={`group-lang-filled-${l}`} />}
          </button>
        ))}
      </div>
      <p className="text-[11px] text-slate-500" data-testid="group-fallback-hint">{t("groupEmail.fallbackHint")}</p>
      <EmailTemplatePicker key={lang} subject={v.subject} body={v.body} t={t}
        onPick={(tpl) => onChange(lang, { subject: tpl.subject, body: tpl.body })} />
      <label className="block text-xs text-slate-400">{t("admin.emailSubject")} ({lang.toUpperCase()})
        <Input value={v.subject} onChange={set("subject")} maxLength={200} className={`${field} mt-1`} data-testid="group-subject" />
      </label>
      <label className="block text-xs text-slate-400">{t("admin.emailBody")} ({lang.toUpperCase()})
        <Textarea value={v.body} onChange={set("body")} rows={10} maxLength={10000} className={`${field} mt-1 font-sans`} data-testid="group-body" />
      </label>
      <div className="text-[11px] text-slate-500">{t("admin.emailPlaceholders")}</div>
    </div>
  );
}
